export const getCallLink = (phoneNumber) => `tel:${phoneNumber}`;

export const getWhatsAppLink = (phoneNumber, job = {}, options = {}) => {
  let cleanNumber = phoneNumber.replace(/\D/g, '');
  if (!cleanNumber.startsWith('260')) {
    cleanNumber = '260' + cleanNumber;
  }

  const jobTitle = job.title || 'your job posting';
  const location = job.city ? ` in ${job.city}` : '';
  const category = job.category ? ` (${job.category})` : '';

  let text;
  if (options.messageType === 'hired') {
    const employerName = job.user?.firstName || 'there';
    text = `Hello ${employerName},%0A%0AThank you for selecting me for the ${jobTitle} job through TumaJobs.%0A%0AI am happy to accept the job.%0A%0ACould you please confirm:%0A• Reporting date and time%0A• Exact location%0A• Any tools or materials I should bring%0A• Any other instructions before starting%0A%0AThank you.`;
    return `https://wa.me/${cleanNumber}?text=${text}`;
  }

  const message = `Hello, I saw your job posting for "${jobTitle}"${location}${category}. Is it still available?`;
  return `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;
};
